import React from 'react';
import { ApplicationActions } from 'components/ApplicationActions';
import { parseDate } from 'utils/date';
import { Status } from 'components/Status';

export const ApplicationInfo = ({ application, showMessage }) => {
  if (!application) return null;

  return (
    <>
      <div className="box">
        <div className="box-header">
          <div className="grid">
            <div className="col s1of2">
              <span className="text-22">{application.companyInfo.name}</span>
            </div>
            <div className="col s1of2 text-14 text-right">
              Umsókn {parseDate(application.createdDate)}{' '}
              {/* <Status statusID={application.statusID} /> */}
            </div>
          </div>
        </div>

        <div className="grid">
          <div className="col s1of4">
            <strong>Kennitala</strong>
          </div>
          <div className="col s3of4">{application.companyInfo.regno}</div>
        </div>
        <div className="grid">
          <div className="col s1of4">
            <strong>Rekstrarform</strong>
          </div>
          <div className="col s3of4">{application.companyInfo.legalForm}</div>
        </div>
        <div className="grid">
          <div className="col s1of4">
            <strong>Starfsemi</strong>
          </div>
          <div className="col s3of4">{application.companyInfo.operation}</div>
        </div>
        <div className="grid">
          <div className="col s1of4">
            <strong>Aðsetur</strong>
          </div>
          <div className="col s3of4">
            {application.companyInfo.postalAddress}, {application.companyInfo.postalCode}{' '}
            {application.companyInfo.postalPostalCodeCommune}
          </div>
        </div>
        <div className="grid">
          <div className="col s1of4">
            <strong>Netfang</strong>
          </div>
          <div className="col s3of4">{application.companyInfo.email}</div>
        </div>

        <div
          className="gutter-top spacer"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            borderTop: '1px solid #efefef'
          }}
        ></div>
        <ApplicationActions application={application} showMessage={showMessage} />
      </div>

      <div
        className="gutter-top"
        style={{ display: 'flex', justifyContent: 'space-between' }}
      ></div>
      <div className="gutter-top"></div>
    </>
  );
};
// const application = {
//   revenue: [
//     {
//       applicationID: 0,
//       revenueId: 0,
//       date: '2020-03-28T01:16:56.788Z',
//       value: 0,
//       insertedBy: 0,
//       insertedDate: '2020-03-28T01:16:56.788Z',
//       updatedBy: 0,
//       updatedDate: '2020-03-28T01:16:56.788Z'
//     }
//   ],
//   applicant: {
//     applicationId: 0,
//     userId: 0,
//     regno: 'string',
//     name: 'string',
//     agreement: 'string',
//     approvalDate: '2020-03-28T01:16:56.788Z',
//     insertedDate: '2020-03-28T01:16:56.788Z'
//   },
//   contact: {
//     applicationId: 0,
//     name: 'string',
//     phoneNumber: 'string',
//     email: 'string'
//   },
//   companyInfo: {
//     regno: '1010102222',
//     name: 'Fyrirtaeki a',
//     postalAddress: 'Gunnarshólmi',
//     postalCode: '111',
//     postalPostalCodeCommune: 'Reykjavík',
//     isCurrent: true,
//     operation: 'Innheimtuþjónusta',
//     legalForm: 'Hlutaféla',
//     website: 'www.gunnarsholmi.is',
//     email: 'mail@gu.is'
//   },
//   applicationId: 11111,
//   applicationGuid: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
//   subjectRegno: 'string',
//   statusID: 0,
//   statusChangeBy: 122,
//   statusChangeDate: '2020-03-28T01:16:56.788Z',
//   createdBy: 122,
//   createdDate: '2020-03-28T01:16:56.788Z',
//   updatedBy: 0,
//   updatedDate: '2020-03-28T01:16:56.788Z',
//   loanMainLenderRegno: 'string',
//   applicantFreezeMonthsRequested: 0,
//   applicantHasUsedOtherResolutions: true,
//   applicantComment: 'string',
//   applicantForecastComment: 'string',
//   reviewerComment: 'string',
//   freezeLoanFrom: '2020-03-28T01:16:56.788Z',
//   freezeLoanTo: '2020-03-28T01:16:56.788Z'
// };
